import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { SendMailModel } from 'src/app/entities/contact-us';
import {MsalService} from '@azure/msal-angular';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };


@Injectable()
export class UserManagementService {

  constructor(private _http: HttpClient,private msal: MsalService) { }


  getAllUsers(): any {
    return this._http.get(environment.APIEndpoint + 'api/User/GetUserList')
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getAllUserLogs(): any {
    return this._http.get(environment.APIEndpoint + 'api/User/GetUserLogsList')
      .map((res) => res)
      .catch(this._errorHandler);
  }

  /*downloadImage(logo) {
        
    return Observable.create((observer: any) => {

        let xhr = new XMLHttpRequest();
      xhr.open('GET', environment.APIEndpoint + 'api/User/DownloadImage?imageLink=' + logo);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.responseType = 'blob';
        const urls=environment.APIEndpoint + 'api/User/DownloadImage?imageLink=' + logo;
        var silentRequest: SilentRequest ={
          account: this.msal.instance.getActiveAccount(),
          scopes: ["user.read"]
      };
        //const resource = this.msal.GetResourceForEndpoint(urls);
        this.msal.acquireTokenSilent(silentRequest).subscribe((tokenResponse: AuthenticationResult) => {
          xhr.setRequestHeader('Authorization', 'Bearer ' + tokenResponse.idToken);
          xhr.setRequestHeader('Url',urls);
          let email= sessionStorage.getItem('userName');
          xhr.setRequestHeader('UserEmail',email);
          xhr.onreadystatechange = function () { 

            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var contentType = 'arraybuffer';
                    var blob = new Blob([xhr.response], { type: contentType });
                    observer.next(blob);
                    observer.complete();
                } else {

                    observer.error(xhr.response);
                }
            }
        }
      xhr.send();
        });
           
       
    });
  }*/


 downloadImage(logo : any): Observable<Blob> {
    return this._http.get(environment.APIEndpoint + 'api/User/DownloadImage?imageLink=' + logo, {
      responseType: 'blob'
    })
      .map((res) => res)
      .catch(this._errorHandler);
  }
 /* downloadImage(logo) {
        
    return Observable.create((observer: any) => {

        let xhr = new XMLHttpRequest();
      xhr.open('GET', environment.APIEndpoint + 'api/User/DownloadImage?imageLink=' + logo);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.responseType = 'blob';
        const urls=environment.APIEndpoint + 'api/User/DownloadImage?imageLink=' + logo;
        const resource = this.adal.GetResourceForEndpoint(urls);
        const token=this.adal.acquireToken(resource).subscribe((token: string) => {
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
          xhr.onreadystatechange = function () { 

            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var contentType = 'arraybuffer';
                    var blob = new Blob([xhr.response], { type: contentType });
                    observer.next(blob);
                    observer.complete();
                } else {

                    observer.error(xhr.response);
                }
            }
        }
      xhr.send();
        });
           
       
    });
  }*/


  uploadProfilePhoto(imageDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/User/UploadProfilePhoto', imageDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  addUser(userEmail):any {
    return this._http.post(environment.APIEndpoint + 'api/User/AddNewUser', userEmail)
    .map((res: Response) => res);
}

deleteUser(userId: number):any {
  return this._http.delete(environment.APIEndpoint + 'api/User/DeleteUser?userId=' + userId)
  .map((res: Response) => res);
}


  addEyRoleList(mappedRoles: any) {
   // const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this._http.post(environment.APIEndpoint + 'api/MasterList/AddEyRoleList', mappedRoles)
      .map((res: Response) => res);
  }

  _errorHandler(error: Response) {
    return Observable.throwError(error || 'Server Error');
  }

  deleteMasterList(roleMappingId:any): any {
    return this._http.delete(environment.APIEndpoint + 'api/MasterList/DeleteMasterList?mappingId='+roleMappingId)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getContactUsList(pageNumber: number) : any {
    return this._http.get(environment.APIEndpoint + 'api/User/GetContactUsList?pageNumber='+pageNumber)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  sendEmailToContact(sendMailModel: SendMailModel): any{
    return this._http.post(environment.APIEndpoint + 'api/User/SendEmailToContact', sendMailModel)
    .map((res: Response) => res);    
  }
}
